module.exports = __webpack_public_path__ + "img/7.a3e9fcc5.jpg";